import Vue from 'vue'
import Card from './Card'
import Child from './Child'
import Button from './Button'
import Checkbox from './Checkbox'
// import {HasError, AlertError, AlertSuccess} from 'vform'
import {HasError, AlertError, AlertSuccess} from 'vform/src/components/bootstrap4'

import Footer from "./Footer";
import Sidebar from "./Sidebar";
import RequestStatusBadge from "./requests/RequestStatusBadge";
import RequestsLoader from "./loaders/RequestsLoader";
import RequestLoader from "./loaders/RequestLoader";
import RequestTableItem from "./requests/RequestTableItem";
import Select2 from 'v-select2-component';
import draggable from 'vuedraggable';

Vue.component('pagination', require('laravel-vue-pagination'));

// Components that are registered globaly.
[
    Card,
    Child,
    Button,
    Checkbox,
    HasError,
    AlertError,
    AlertSuccess,
    Footer,
    Sidebar,
    RequestStatusBadge,
    RequestsLoader,
    RequestLoader,
    RequestTableItem,
    Select2,
    draggable
].forEach(Component => {
    Vue.component(Component.name, Component)
});
